import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Box } from '@material-ui/core';
import AdminLayout from '../../layouts/AdminLayout';
import useSWR from 'swr';
import { fetcher } from '../../utils/api';
import SearchBar from '../../components/SearchBar';
import Header from './Header';
import PaymentsTable from './PaymentsTable';
import Loading from '../../components/Loading';

const useStyles = makeStyles(() => ({
  root: {
    padding: 24,
  },
  results: {
    marginTop: 12,
  },
}));

const Payments = () => {
  const classes = useStyles();
  const [payments, setPayments] = React.useState([]);
  const [filteredPayments, setFilteredPayments] = React.useState([]);

  const { data } = useSWR('/v2/payouts', fetcher);

  useEffect(() => {
    if (data?.code === 200) {
      setPayments(data.result);
      setFilteredPayments(data.result);
    }
  }, [data]);

  const handleSearch = () => {};

  console.log(filteredPayments)

  return (
    <AdminLayout>
      <Box className={classes.root}>
        <Loading loading={!data?.result} />
        <Header />
        <SearchBar onSearch={handleSearch} />
        <PaymentsTable payments={filteredPayments} />
      </Box>
    </AdminLayout>
  );
};

export default Payments;
